import React, { useEffect } from "react";
import articlesStore from "../../store/articles/ArticlesStore";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getArticles } from "../../store/articles/ArticlesApi";
import { Button, Switch, TableCell, Typography } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import { getSupergroupsFromStores } from "../../store/articles/ArticlesHelpers";
import { useDialog } from "../Dialogs/DialogProvider";
import AddSupergroupDialog from "./AddSupergroupDialog";
import { updateSupergroup, updateSupergroups } from "../../store/SupergroupApi";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import TableHead from "@material-ui/core/TableHead";
import { CreateSupergroup } from "../../store/articles/models/Supergroup";
import TranslationFormButton from "../TranslationForm/TranslationFormButton";
import cloudStore from "../../store/CloudStore";

function SupergroupArticles() {
  const merchantId = Number.parseInt(useParams().merchantId);
  const [supergroups, setSupergroups] = React.useState(null);
  const [openDialog] = useDialog();

  const onMenuUpdated = () => {
    if (articlesStore.supergroups != null) {
      setSupergroups(getSupergroupsFromStores());
    } else {
      setSupergroups(null);
    }
  };

  useEffect(() => {
    articlesStore.on(articlesStore.events.MENU_UPDATED, onMenuUpdated);
    return () => {
      articlesStore.removeListener(articlesStore.events.MENU_UPDATED, onMenuUpdated);
    };
  }, []);

  useEffect(() => {
    if (merchantId !== articlesStore.merchantId) {
      if (supergroups != null) {
        setSupergroups(null);
      }
      getArticles(merchantId);
    } else if (supergroups == null && articlesStore.supergroups != null) {
      onMenuUpdated();
    }
  }, []);

  if (!supergroups) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    let destinationIndex = result.destination.index;
    let sourceIndex = result.source.index;
    if (destinationIndex === sourceIndex) {
      return;
    }

    supergroups.splice(destinationIndex, 0, supergroups.splice(sourceIndex, 1)[0]);

    updateSupergroups(
      merchantId,
      supergroups,
      supergroups.map((supergroup, index) => ({ priority: 1000 - index }))
    ).then(() => {
      setSupergroups(supergroups);
    });
  };

  return (
    <div>
      <div style={{ display: "flex", flexFlow: "wrap" }}>
        <Button
          key={null}
          style={{ margin: "8px 16px" }}
          variant={"outlined"}
          color={"primary"}
          onClick={() => {
            openDialog({
              children: (
                <AddSupergroupDialog
                  onSubmit={(e, supergroup) => {
                    if (supergroups?.length > 0) {
                      supergroup.priority = supergroups[supergroups.length - 1].priority - 1;
                    }
                    updateSupergroup(merchantId, supergroup, supergroup).then(() => {
                      getArticles(merchantId);
                    });
                  }}
                />
              ),
            });
          }}
        >
          new supergroup
        </Button>

        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId={"droppable-paymentmethods"} type="PAYMENTMETHOD">
            {(provided) => (
              <Table innerRef={provided.innerRef} {...provided.droppableProps}>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>
                      <Typography>ID</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>Supergroup</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>Visible</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                {supergroups.map((supergroup, index) => (
                  <Draggable
                    type="Supergroup"
                    index={index}
                    key={supergroup.updatedAt}
                    draggableId={"draggable-" + supergroup.id}
                  >
                    {(provided, snapshot) => (
                      <TableRow innerRef={provided.innerRef} {...provided.draggableProps}>
                        <TableCell>
                          <div
                            {...provided.dragHandleProps}
                            style={{
                              cursor: "move",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                            }}
                          >
                            <DragHandleIcon
                              style={{
                                marginLeft: 0,
                                marginRight: 10,
                              }}
                            />
                          </div>
                        </TableCell>
                        <TableCell>{supergroup.id}</TableCell>
                        <TableCell>
                          {supergroup.tag}
                          {/*<EditTextField*/}
                          {/*  value={supergroup.name}*/}
                          {/*  onBlur={(value, setBeginValue) => {*/}
                          {/*    updateSupergroup(merchantId, supergroup, { name: value }).then((supergroupData) => {*/}
                          {/*      let newSupergroups = [...supergroups];*/}
                          {/*      newSupergroups.splice(index, 1, CreateSupergroup(supergroupData));*/}
                          {/*      setSupergroups(newSupergroups);*/}
                          {/*    });*/}
                          {/*  }}*/}
                          {/*/>*/}
                        </TableCell>
                        <TableCell>
                          <Switch
                            color={"primary"}
                            checked={supergroup.manual_active == 1}
                            onChange={(e) => {
                              updateSupergroup(merchantId, supergroup, { manual_active: e.target.checked }).then(
                                (supergroupData) => {
                                  let newSupergroups = [...supergroups];
                                  newSupergroups.splice(index, 1, CreateSupergroup(supergroupData));
                                  setSupergroups(newSupergroups);
                                }
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <div style={{ width: 20 }}>
                            <TranslationFormButton
                              translationField={"Supergroup"}
                              updateTranslations={(language, value) => {
                                return updateSupergroup(merchantId, supergroup, {
                                  translation: { [language]: value },
                                }).then((supergroupData) => {
                                  let newSupergroups = [...supergroups];
                                  let newSupergroup = CreateSupergroup(supergroupData);
                                  newSupergroup.translation = supergroup.translation ?? {};
                                  newSupergroup.translation[language] = value;
                                  newSupergroups.splice(index, 1, newSupergroup);

                                  setSupergroups(newSupergroups);
                                });
                              }}
                              translationsObject={supergroup.translation ?? {}}
                              translationFields={cloudStore.merchant.languages
                                ?.filter((language) => language.active)
                                .map((object) => object.language)}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
              </Table>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default SupergroupArticles;
